import {
  GET_DASHBOARD_ACCESSIBILITY_STATUS,
  GET_DASHBOARD_ACCESSIBILITY_STATUS_SUCCESS,
  GET_DASHBOARD_ACCESSIBILITY_STATUS_FAILED,
} from "../actions/dashboardsAccessibility";

export const initialStateDashboardAccessibility = {
  dashboardAccessibility: {
    loading: false,
    error: null,
    data: [
      {
        dashboard: null,
        isDashboardAccessible: {
          msg: null,
          accessEnabled: null,
        },
      },
    ],
  },
};

export function dashboardAccessibilityReducer(
  state = initialStateDashboardAccessibility,
  action
) {
  switch (action.type) {
    case GET_DASHBOARD_ACCESSIBILITY_STATUS:
      return {
        ...state,
        dashboardAccessibility: {
          loading: true,
          error: null,
          data: [
            ...state.dashboardAccessibility.data,
            //   {
            //   dashboard: action.tab,
            //   isDashboardAccessible: {
            //     msg: null,
            //     accessEnabled: null
            //   }
            // }
          ],
        },
      };

    case GET_DASHBOARD_ACCESSIBILITY_STATUS_SUCCESS:
      let dashboardObj = state.dashboardAccessibility.data.findIndex(
        (obj) => obj.dashboard === action.tab
      );

      if (dashboardObj) {
        state.dashboardAccessibility.data.splice(dashboardObj, 1);
      }

      return {
        ...state,
        dashboardAccessibility: {
          loading: false,
          error: null,
          data: [
            ...state.dashboardAccessibility.data,
            {
              dashboard: action.tab,
              isDashboardAccessible: {
                msg: action.payload.content.msg,
                accessEnabled: action.payload.content.accessEnabled,
              },
            },
          ],
        },
      };

    case GET_DASHBOARD_ACCESSIBILITY_STATUS_FAILED:
      return {
        ...state,
        dashboardAccessibility: {
          loading: false,
          error: action.error,
          data: [
            ...state.dashboardAccessibility.data,
            {
              dashboard: action.tab,
              isDashboardAccessible: {
                msg: "not accessible",
                accessEnabled: false,
              },
            },
          ],
        },
      };

    default:
      return state;
  }
}

export default dashboardAccessibilityReducer;
